import angular from 'angular';
import insuranceSendReportForm from './insuranceSendReportForm';
import './style.scss';

export default angular
  .module('component.insuranceSendReportForm', [])
  .component('insuranceSendReportForm', insuranceSendReportForm).name;
